var _excluded = ["className"],
  _excluded2 = ["className"],
  _excluded3 = ["isDisabled", "children", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Icon } from '../icon';
import { tqc, forwardRef, omitThemingProps, StylesProvider, useMultiStyleConfig, useStyles } from '../../system';
import { cx, __DEV__ } from '../../utils';
import * as React from 'react';
/**
 * The tag component is used to label or categorize UI elements.
 * To style the tag globally, change the styles in `theme.components.Tag`
 */
export var Tag = forwardRef((props, ref) => {
  var {
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var styles = useMultiStyleConfig('Tag', rest);
  var ownProps = omitThemingProps(rest);
  var containerStyles = _objectSpread({
    display: 'inline-flex',
    verticalAlign: 'top',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '100%'
  }, styles.container);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(tqc.span, _extends({
    className: cx('tqc-tag', className),
    ref: ref
  }, ownProps, {
    __css: containerStyles
  })));
});
if (__DEV__) {
  Tag.displayName = 'Tag';
}
export var TagLabel = forwardRef((props, ref) => {
  var {
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.span, _extends({
    className: cx('tqc-tag__label', className),
    ref: ref,
    isTruncated: true
  }, rest, {
    __css: styles.label
  }));
});
if (__DEV__) {
  TagLabel.displayName = 'TagLabel';
}
export var TagLeftIcon = forwardRef((props, ref) => /*#__PURE__*/React.createElement(Icon, _extends({
  ref: ref,
  verticalAlign: "top",
  marginEnd: "0.5rem"
}, props)));
if (__DEV__) {
  TagLeftIcon.displayName = 'TagLeftIcon';
}
export var TagRightIcon = forwardRef((props, ref) => /*#__PURE__*/React.createElement(Icon, _extends({
  ref: ref,
  verticalAlign: "top",
  marginStart: "0.5rem"
}, props)));
if (__DEV__) {
  TagRightIcon.displayName = 'TagRightIcon';
}
var TagCloseIcon = props => /*#__PURE__*/React.createElement(Icon, _extends({
  width: 3,
  viewBox: "0 0 352 512",
  focusable: "false",
  "aria-hidden": true
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
}));
if (__DEV__) {
  TagCloseIcon.displayName = 'TagCloseIcon';
}
/**
 * TagCloseButton is used to close "remove" the tag
 */
export var TagCloseButton = props => {
  var {
      isDisabled,
      children,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  var styles = useStyles();
  var btnStyles = _objectSpread({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: '0',
    transition: 'all 0.2s'
  }, styles.closeButton);
  return /*#__PURE__*/React.createElement(tqc.button, _extends({}, rest, {
    type: "button",
    "aria-label": "close",
    disabled: isDisabled,
    className: cx('tqc-tag__close-button', className),
    __css: btnStyles
  }), children || /*#__PURE__*/React.createElement(TagCloseIcon, null));
};
if (__DEV__) {
  TagCloseButton.displayName = 'TagCloseButton';
}